import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import { fragments } from '../../../../gql'

const DOC = gql`
  ${fragments.breadcrumb.DOC}
  query MosaicPageRenderingInfo(
    $appPageId: ID!
    $scenarioId: ID!
    $appId: ID!
    $zoneId: ID!
    $tenantId: ID!
    $variableOverrides: [VariableValueInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            mosaicPageRendering(
              appPageId: $appPageId
              variableOverrides: $variableOverrides
            ) {
              info {
                title
                breadcrumbs {
                  ...FragmentBreadcrumb
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicPageRenderingInfoQuery,
  ents.core.mosaic.Page.Rendering,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'mosaicPageRendering',
          graphql.transformers.OUT.select(
            'info',
            graphql.transformers.OUT.object({
              breadcrumbs: graphql.transformers.OUT.list(
                fragments.breadcrumb.TRANSFORMER,
                { onNullish: 'remove' },
              ),
              title: transformers.PASS_THROUGH,
            }),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicPageRenderingInfoQuery,
  ents.core.mosaic.Page.Rendering | undefined,
  graphql.schema.MosaicPageRenderingInfoQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
